import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const HeaderWrapper = styled.header`
  background: ${({ theme }) => theme.colors.bgColor};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  position: sticky;
  top: 0;
  z-index: 100;
`;

export const TopBar = styled.div`
  background: ${({ theme }) => theme.colors.secondary.main};
  color: ${({ theme }) => theme.colors.primary.dark};
  padding: 6px 0;
  font-size: ${({ theme }) => theme.typography.sizes.xs};
  text-align: center;
  font-weight: 600;
`;

export const MainBar = styled.div`
  max-width: ${({ theme }) => theme.metrics.contentMaxWidth};
  margin: 0 auto;
  padding: 16px ${({ theme }) => theme.metrics.paddingHorizontal};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
`;

export const Logo = styled(Link)`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
`;

export const LogoImage = styled.img`
  height: 60px;
  width: auto;
`;

export const SearchWrapper = styled.div`
  width: 100%;
`;

export const IconGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const IconLink = styled(Link)`
  color: ${({ theme }) => theme.colors.text.dark.very};
  font-size: 20px;
  position: relative;
  display: flex;
  align-items: center;

  &:hover {
    color: ${({ theme }) => theme.colors.primary.main};
  }
`;

export const CartBadge = styled.span`
  position: absolute;
  top: -8px;
  right: -10px;
  background: ${({ theme }) => theme.colors.secondary.main};
  color: ${({ theme }) => theme.colors.primary.dark};
  font-size: 10px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${({ theme }) => theme.typography.body};
`;

export const NavBar = styled.nav`
  background: ${({ theme }) => theme.colors.primary.main};
`;

export const NavInner = styled.div`
  max-width: ${({ theme }) => theme.metrics.contentMaxWidth};
  margin: 0 auto;
  padding: 0 ${({ theme }) => theme.metrics.paddingHorizontal};
  display: flex;
  align-items: center;
  gap: 32px;
`;

export const NavLink = styled(Link)`
  color: ${({ theme }) => theme.colors.text.light.very};
  font-size: ${({ theme }) => theme.typography.sizes.md};
  font-weight: 500;
  padding: 12px 0;
  border-bottom: 2px solid transparent;
  transition: all 0.2s;

  &:hover {
    color: ${({ theme }) => theme.colors.secondary.main};
    border-bottom-color: ${({ theme }) => theme.colors.secondary.main};
  }
`;

export const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  font-size: 24px;
  color: ${({ theme }) => theme.colors.text.dark.very};

  @media (max-width: 768px) {
    display: block;
  }
`;

export const DesktopNav = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
`;

export const DesktopSearch = styled.div`
  flex: 1;
  min-width: 0;

  @media (max-width: 768px) {
    display: none;
  }
`;
